import React, { createContext, useContext } from 'react';
import { useJwt } from "react-jwt";
import { useProvideAuth } from './auth-methods/jwt-auth';

const authContext = createContext();
// Provider component that wraps your app and makes auth object ..
// ... available to any child component that calls useAuth().

export function AuthProvider({ children }) {
  const token = localStorage.getItem('token');
  let { decodedToken, isExpired } = useJwt(token);
  if(!decodedToken) {
    isExpired = true ;
  }
  const auth = useProvideAuth(isExpired);
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.

export const useAuth = () => {
  return useContext(authContext);
};
